import React from 'react';
import '../App.css';
export class Bodywaitbuy extends React.Component {
    render() {
        return (
            <div className='sshbodyappContainerLogin'>
                <div className='sshbodyappContainerLoginCarrusel'>

                </div>
                <div className='sshbodyappContainerLoginForm'>
                    <div class='container'>
                        <div className='loader'></div>
                    </div>
                </div>
            </div>            
        );
    }
}
